import { ROUTES_APLICATION } from '@constants/routes-aplication.constants';
import { MenuConfigModel } from '@core/models/outros/menu-config.model';
import { ApplicationModules } from '@enums/application-modules.enum';
import { UserTypeEnum } from '@enums/user-type.enum';

export const MENU_FINANCIAL: MenuConfigModel = {
  id: ApplicationModules.FINANCIAL,
  icon: 'attach_money',
  name: 'Financeiro',
  text: 'Cadastre e organize as <strong>parcerias financeiras</strong>, além de controlar os <strong>pagamentos</strong>.',
  onlyAssociated: true,
  profilesToShowItems: [
    UserTypeEnum.ADMINISTRADOR,
    UserTypeEnum.SUPERVISOR,
    UserTypeEnum.FINANCEIRO,
  ],
  submenus: [
    {
      name: 'Lançamento Financeiro',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.release}`,
    },
    {
      name: 'Fluxo de Caixa',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.cashFlow}`,
    },
    // {
    //   name: 'Previsão Orçamentária Anual',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.SUPERVISOR,
    //     UserTypeEnum.FINANCEIRO,
    //   ],
    //   route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.budgetForecast}`,
    // },
    // {
    //   name: 'Relatório Previsão Orçamentária Anual',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.SUPERVISOR,
    //     UserTypeEnum.FINANCEIRO,
    //   ],
    //   route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.relatorioPrevisaoOrcamentaria}`,
    // },
    {
      name: 'Pessoas',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.people}`,
    },
    {
      name: 'Bancos',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.bank}`,
    },
    {
      name: 'Centro de Custo',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.resultCenter}`,
    },
    {
      name: 'Conta Corrente',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.bankAccount}`,
    },
    // {
    //   name: 'Contratos',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.SUPERVISOR,
    //     UserTypeEnum.FINANCEIRO,
    //   ],
    //   route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.contracts}`,
    // },
    {
      name: 'Controle Bloqueio de CFC',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.blockCfc}`,
    },
    {
      name: 'Forma Pagamento',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.paymentMode}`,
    },
    {
      name: 'Grupo de Lançamento',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.releaseGroup}`,
    },
    // {
    //   name: 'Grupo Financeiro',
    //   onlyAssociated: true,
    //   profilesToShowItems: [
    //     UserTypeEnum.ADMINISTRADOR,
    //     UserTypeEnum.SUPERVISOR,
    //     UserTypeEnum.FINANCEIRO,
    //   ],
    //   route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.financialGroup}`,
    // },
    {
      name: 'Modos de Pagamentos',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.accountPayment}`,
    },
    {
      name: 'Categorias Financeira',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.releaseTypes}`,
    }, 
    {
      name: 'Contas DRE',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.accountDre}`,
    },
    {
      name: 'Mensalidade Associativa',
      onlyAssociated: true,
      profilesToShowItems: [
        UserTypeEnum.ADMINISTRADOR,
        UserTypeEnum.SUPERVISOR,
        UserTypeEnum.FINANCEIRO,
      ],
      route: `/${ROUTES_APLICATION.financial.path}/${ROUTES_APLICATION.financial.membershipFee}`,
    }
  ],
}
